<template>
  <UIDialog :is-open :title :z-index size="md" @close="handleClose">
    <AssetForm
      :instance="modal.entity"
      toggledEOD
      :hideEODSearch
      @close="handleClose"
    />
  </UIDialog>
</template>

<script setup lang="ts">
import { computed, provide } from 'vue'

import { AssetClass } from '..'
import { ModalClass } from '@types'

import { ASSET_MODAL_TITLE, ASSET_MODAL_TITLE_NEW } from './utils/const'

import { UIDialog } from '@ui/modals'
import AssetForm from './AssetForm.vue'

type Props = {
  modal: ModalClass<AssetClass>
  restrictions?: string[]
  hideEODSearch?: boolean
}
const props = defineProps<Props>()

const title = computed(() =>
  props.modal.entity.isNew ? ASSET_MODAL_TITLE_NEW : ASSET_MODAL_TITLE,
)

const isOpen = computed(() => props.modal.isOpened)

const zIndex = computed(() => props.modal.zIndex)

provide('restrictions', props.restrictions)

const handleClose = () => {
  props.modal.conditionalClose()
}
</script>
